import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { createEffectFactory } from '@recruitee/ngrx';

import { RewardHttpClient } from './reward.http-client';
import { ReferralsRewardActions } from './reward.store';

@Injectable({ providedIn: 'root' })
export class ReferralsRewardEffects {
  public effects = createEffectFactory(ReferralsRewardActions, this.actions$);

  public fetch$ = this.effects(ReferralsRewardActions.fetchPaginatedCollection, ({ payload }) =>
    this.http.loadRewards(payload.params).pipe(
      map(data => ({
        data,
      })),
    ),
  );

  public create$ = this.effects(ReferralsRewardActions.createOnePessimistic, ({ payload }) =>
    this.http.createReward(payload.data).pipe(map(data => ({ data }))),
  );

  public update$ = this.effects(ReferralsRewardActions.updateOnePessimistic, ({ payload }) =>
    this.http.updateReward(payload).pipe(map(data => ({ data }))),
  );

  public deleteAll$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ReferralsRewardActions.deleteMany),
      switchMap(({ payload }) =>
        this.http.deleteReward(payload.ids).pipe(
          switchMap(() => [ReferralsRewardActions.deleteManySuccess({ payload })]),
          catchError((error: HttpErrorResponse) =>
            of(ReferralsRewardActions.deleteManyFailed({ payload: { error, data: payload } })),
          ),
        ),
      ),
    ),
  );

  constructor(
    private actions$: Actions,
    private http: RewardHttpClient,
  ) {}
}
